import React from 'react';

interface LegalModalProps {
  title: string;
  content: string;
  onClose: () => void;
}

const LegalModal: React.FC<LegalModalProps> = ({ title, content, onClose }) => {
  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-75 overflow-y-auto h-full w-full z-50 flex items-center justify-center p-4">
      <div className="relative mx-auto border w-full max-w-3xl shadow-lg rounded-md bg-white">
        <div className="p-5">
            <div className="flex justify-between items-start">
                <h3 className="text-2xl leading-6 font-bold text-gray-900">{title}</h3>
                <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-3xl font-bold -mt-2">&times;</button>
            </div>
            <div className="mt-4 max-h-[70vh] overflow-y-auto pr-4">
                <p className="text-sm text-gray-700 whitespace-pre-wrap">{content}</p>
            </div>
        </div>
        <div className="items-center px-4 py-3 border-t bg-gray-50 flex justify-end rounded-b-md">
            <button
                onClick={onClose}
                className="px-4 py-2 bg-primary text-white text-base font-medium rounded-md w-auto shadow-sm hover:bg-primary-light focus:outline-none focus:ring-2 focus:ring-primary-dark"
            >
                Close
            </button>
        </div>
      </div>
    </div>
  );
};

export default LegalModal;
